<template>
	<div class="hiq-digital-resources">
		<SearchField/>
		<Filters/>
		<SearchSort/>
		<Message/>
		<ItemsBlock/>
	</div>
</template>

<script lang="ts">
import Vue from 'vue'
import SearchField from './components/SearchField.vue';
import Filters from './components/Filters.vue';
import Message from './components/Message.vue';
import ItemsBlock from './components/ItemsBlock.vue';
import SearchSort from './components/SearchSort.vue';

export default Vue.extend<{}, {}, {}, {}>({
	name: 'app',

	components: {
    SearchField,
    Filters,
    Message,
    ItemsBlock,
    SearchSort
},
})
</script>
